module.exports = __webpack_public_path__ + "static/img/wechat.49dce931.jpg";